import { TranslateService } from '@ngx-translate/core';

export function resolveCurrencyDisplayName(
  translate: TranslateService,
  code: string | null | undefined,
  fallback?: string | null,
): string {
  const normalizedCode = (code ?? '').trim().toUpperCase();
  if (!normalizedCode) {
    return (fallback ?? '').trim();
  }

  const key = `CURRENCIES.${normalizedCode}`;
  const translated = translate.instant(key);
  if (translated && translated !== key) {
    return translated;
  }

  return (fallback ?? '').trim() || normalizedCode;
}
